// extracted by mini-css-extract-plugin
export default {"section":"EventsSection_section__QZFC+","scrollControlsContainer":"EventsSection_scrollControlsContainer__V9bLm","eventsGrid":"EventsSection_eventsGrid__Eb1jM"};